
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/press-contacts",
      function () {
        return require("private-next-pages/[lang]/press-contacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/press-contacts"])
      });
    }
  